import { useMultiBranch } from "@/lib/branchInfo";

// The branch a record is filed under, as a small line under its number. Hidden when there is only one branch.
export function BranchTag({ row }) {
  const multi = useMultiBranch();
  if (!multi || !row?.branch_name) return null;
  return <span className="block text-[11px] font-normal text-muted-foreground" data-testid="branch-tag">{row.branch_name}</span>;
}
